import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const StatCard = ({ icon, color, stat, label, subtitle, trend, iconType = 'lucide', theme, link, onLinkClick }) => {
    const renderIcon = () => {
        if (iconType === 'fontawesome') {
          return (
            <FontAwesomeIcon
              icon={icon}
              size="xl"
              style={{ color: color }}
              className="transition-all duration-300 group-hover:rotate-6"
            />
          );
        } else {
          // Default to Lucide icons
          return React.createElement(icon, {
            size: 28,
            style: { color: color },
            className: "transition-all duration-300 group-hover:rotate-6"
          });
        }
      };
      return (
        <div className="group relative overflow-hidden rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1" 
        style={{ backgroundColor: theme?.background?.card, border: `1px solid ${theme?.primary?.gray?.[300]}`,maxWidth: '300px' }}>
          {/* Gradient background accent */}
          {/* <div 
            className="absolute top-0 right-0 w-24 h-24 opacity-20 rounded-full blur-xl transition-all duration-300 group-hover:opacity-40"
            style={{ backgroundColor: `${color}` }}
          /> */}
          
          {/* Row 1: Icon and Stat/Trend */}
          <div className="relative z-10 flex items-center justify-between mb-3">
            <div 
              className="flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
            >
              {renderIcon()}
            </div>
            
            
            <div className="flex items-baseline gap-2">
              <h3 className="text-2xl font-bold transition-colors duration-300" style={{ color: theme?.primary?.gray?.[900] }}>
                {stat}
              </h3>
              {trend && (
                <span 
                  className="text-xs font-medium px-2 py-1 rounded-full"
                  style={{ 
                    backgroundColor: `${color}15`,
                    color: color 
                  }}
                >
                  {trend}
                </span>
              )}
            </div>
          </div>
          
          {/* Row 2: Label and Subtitle */}
          <div className="relative z-10 mb-2">
            <p className="text-sm font-medium leading-relaxed" style={{ color: theme?.primary?.gray?.[700] }}>
              {label}
            </p>
            {subtitle && (
              <p className="text-xs leading-relaxed mt-1" style={{ color: theme?.primary?.gray?.[500] }}>
                {subtitle}
              </p>
            )}
          </div>
          
          {/* Row 3: Link */}
          {link && (
            <div className="relative z-10">
              <button
                onClick={onLinkClick}
                className="text-xs font-medium py-1 rounded-full transition-all duration-300 hover:scale-105 active:scale-95"
                style={{ 
                  color: theme?.primary?.blue?.[500] 
                }}
              >
                {link} <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          )}
          
          {/* Subtle border glow on hover */}
          <div 
            className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
            style={{ 
              boxShadow: `0 0 0 1px ${color}20`
            }}
          />
        </div>
      );
    };

const StatsGrid = ({ stats, className = "", theme }) => {
  // Calculate dynamic columns based on number of stats
  const getGridCols = (count) => {
    if (count === 1) return 'grid-cols-1';
    if (count === 2) return 'grid-cols-2';
    if (count === 3) return 'grid-cols-2 md:grid-cols-3';
    if (count === 4) return 'grid-cols-2 md:grid-cols-2 lg:grid-cols-4';
    // For 5+ items, use responsive grid that adapts
    return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5';
  };

  const gridColsClass = getGridCols(stats.length);

  return (
    <>
  <style>
    {`
      .study-tools-flex {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1rem;
      }
      
      .study-tools-flex .stat-card {
        flex: 0 0 320px;
        max-width: 320px;
      }
      
      @media (min-width: 1024px) {
        .study-tools-flex {
          gap: 1.5rem;
        }
        .study-tools-flex .stat-card {
          flex: 0 0 calc(25% - 1.125rem);
        }
      }
    `}
  </style>
  <div className="study-tools-flex">
    {stats.map((stat, index) => (
      <div key={index} className="stat-card">
        <StatCard 
          {...stat} 
          theme={theme} 
        />
      </div>
    ))}
  </div>
</>
  );
};

export default StatsGrid;
